
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {NotificationTemplate} from '../core/NotificationTemplate';
import {FieldModelNotificationTemplate} from '../core/NotificationTemplate';

/**
 * NewNotificationTemplates struct
 */
class NewNotificationTemplates {
  /**
   * Initialize struct
   * @param {!Map=} newTemplatesByLanguage
   * @constructor
   */
  constructor (newTemplatesByLanguage = new Map()) {
    this.NewTemplatesByLanguage = newTemplatesByLanguage
  }

  /**
   * Copy struct (shallow copy)
   * @this {!NewNotificationTemplates}
   * @param {!NewNotificationTemplates} other Other struct
   * @returns {!NewNotificationTemplates} This struct
   */
  copy (other) {
    if (other.NewTemplatesByLanguage != null) {
      this.NewTemplatesByLanguage = new Map()
      Object.keys(other.NewTemplatesByLanguage).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = new UUID(key)
          if (other.NewTemplatesByLanguage[key] != null) {
            let tempValue
            tempValue = NotificationTemplate.fromObject(other.NewTemplatesByLanguage[key])
            this.NewTemplatesByLanguage.set(tempKey, tempValue)
          } else {
            this.NewTemplatesByLanguage.set(tempKey, null)
          }
        }
      })
    } else {
      this.NewTemplatesByLanguage = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!NewNotificationTemplates}
   * @returns {!NewNotificationTemplates} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new NewNotificationTemplatesModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new NewNotificationTemplatesModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!NewNotificationTemplates}
   * @param {!NewNotificationTemplates} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof NewNotificationTemplates)) {
      throw new TypeError('Instance of NewNotificationTemplates is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!NewNotificationTemplates}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      NewTemplatesByLanguage: ((this.NewTemplatesByLanguage != null) ? fbe.MapToObject(new Map(Array.from(this.NewTemplatesByLanguage, item => [((item[0] != null) ? item[0].toString() : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return NewNotificationTemplates.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!NewNotificationTemplates} other Object value
   * @returns {!NewNotificationTemplates} Created struct
   */
  static fromObject (other) {
    return new NewNotificationTemplates().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!NewNotificationTemplates}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return NewNotificationTemplates.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!NewNotificationTemplates}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6587
  }
}

export { NewNotificationTemplates };

/**
 * Fast Binary Encoding NewNotificationTemplates field model
 */
class FieldModelNewNotificationTemplates extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.NewTemplatesByLanguage = new fbe.FieldModelMap(new fbe.FieldModelUUID(buffer, 4 + 4), new FieldModelNotificationTemplate(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelNewNotificationTemplates}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelNewNotificationTemplates}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.NewTemplatesByLanguage.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelNewNotificationTemplates}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.NewTemplatesByLanguage.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelNewNotificationTemplates}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelNewNotificationTemplates.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelNewNotificationTemplates}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6587
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelNewNotificationTemplates}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelNewNotificationTemplates}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.NewTemplatesByLanguage.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewTemplatesByLanguage.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTemplatesByLanguage.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelNewNotificationTemplates}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelNewNotificationTemplates}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelNewNotificationTemplates}
   * @param {!NewNotificationTemplates} fbeValue Default value, defaults is new NewNotificationTemplates()
   * @returns {!NewNotificationTemplates} NewNotificationTemplates value
   */
  get (fbeValue = new NewNotificationTemplates()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelNewNotificationTemplates}
   * @param {!NewNotificationTemplates} fbeValue NewNotificationTemplates value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.NewTemplatesByLanguage.fbeSize) <= fbeStructSize) {
      this.NewTemplatesByLanguage.get(fbeValue.NewTemplatesByLanguage)
    } else {
      fbeValue.NewTemplatesByLanguage.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTemplatesByLanguage.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelNewNotificationTemplates}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelNewNotificationTemplates}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelNewNotificationTemplates}
   * @param {!NewNotificationTemplates} fbeValue NewNotificationTemplates value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelNewNotificationTemplates}
   * @param {NewNotificationTemplates} fbeValue NewNotificationTemplates value
   */
  setFields (fbeValue) {
    this.NewTemplatesByLanguage.set(fbeValue.NewTemplatesByLanguage)
  }
}

export { FieldModelNewNotificationTemplates };

/**
 * Fast Binary Encoding NewNotificationTemplates model
 */
class NewNotificationTemplatesModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelNewNotificationTemplates(this.buffer, 4)
  }

  /**
   * Get the NewNotificationTemplates model
   * @this {!NewNotificationTemplatesModel}
   * @returns {!FieldModelNewNotificationTemplates} model NewNotificationTemplates model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!NewNotificationTemplatesModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!NewNotificationTemplatesModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return NewNotificationTemplatesModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!NewNotificationTemplatesModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelNewNotificationTemplates.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!NewNotificationTemplatesModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!NewNotificationTemplatesModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!NewNotificationTemplatesModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!NewNotificationTemplatesModel}
   * @param {!NewNotificationTemplates} value NewNotificationTemplates value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!NewNotificationTemplatesModel}
   * @param {!NewNotificationTemplates} value NewNotificationTemplates value, defaults is new NewNotificationTemplates()
   * @return {!object} Deserialized NewNotificationTemplates value and its size
   */
  deserialize (value = new NewNotificationTemplates()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new NewNotificationTemplates(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new NewNotificationTemplates(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!NewNotificationTemplatesModel}
   * @param {!number} prev Previous NewNotificationTemplates model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { NewNotificationTemplatesModel };
